exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-carousel__item[data-v-16435b6c]:nth-child(2n){background-color:#99a9bf}.el-carousel__item[data-v-16435b6c]:nth-child(odd){background-color:#d3dce6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-16435b6c","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/tenant/configurations/pdf_ticket_templates.vue
// module id = hf2X
// module chunks = 0